import {ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi} from '@angular/common/http';
import {TokenInterceptorService} from '@services/token-interceptor.service';
import {provideAnimations} from '@angular/platform-browser/animations';
import {loadingInterceptor} from '@services/loading.interceptor';
import {provideFeatureFlags} from '@/app/shared/providers/feature-flag.provider';
import { provideClientHydration, withEventReplay, withHttpTransferCacheOptions } from '@angular/platform-browser';

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) => {
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
	providers: [
		provideAnimations(),
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideFeatureFlags(),
		provideHttpClient(
			withFetch(),
			withInterceptorsFromDi()
		),
		provideRouter(
			routes,
			withInMemoryScrolling({
				scrollPositionRestoration: 'enabled',
			})
		),
		{
			provide: LOCALE_ID,
			useValue: 'fr-FR'
		},
		importProvidersFrom(
			[TranslateModule.forRoot({
				loader: {
					provide: TranslateLoader,
					useFactory: httpLoaderFactory,
					deps: [HttpClient]
				}
			})]
		),
		{
			provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true
		}, provideClientHydration(withEventReplay(), withHttpTransferCacheOptions({}))
	]
};
